
import { check } from '../../../../assets';
import { useAppContext } from '../../../../contexts';
import s from './cancelProgressBar.module.css';
import { useCancelProgressBar } from './useCancelProgressBar';

const OrdersProgressBar = (props) => {
    // Destructured props
    const {orderStatus} = props;

    const {stepInfos} = useCancelProgressBar({orderStatus});

    const {highContrast} = useAppContext();
    
    return (
        <div className={s.progressContainer}>
            <div className={s.progressSteps}>
                <div className={`${s.progressStepOneContainer} ${highContrast ? "highGenericWrapper" : "bg-sabin-red-default"}`}>
                    <div className={`rounded-full bg-white w-[25px] h-[25px]`}>
                        <img className={`w-full select-none ${highContrast ? "brightness-0" : ""}`} src={check} alt="check image" />
                    </div>
                </div>
                <div className={`w-full rounded-l-full flex justify-start items-center h-[5px] ${highContrast ? "highGenericWrapper" : "bg-sabin-red-default"} rounded-r-full`}>
                    <div className={`rounded-full bg-white w-[25px] h-[25px] ${stepInfos['second'] === 3 ? '' : 'border-2 border-sabin-red-default'}`}>
                        <img className={`w-full select-none ${highContrast ? "brightness-0" : ""}`} src={check} alt="check image" />
                    </div>
                </div>
                <div className={`
                    ${s.progressStepTwoContainer} 
                    ${stepInfos['third'] === 3 
                        ? `rounded-r-full ${highContrast ? "highGenericWrapper" : "bg-sabin-red-default"}`
                        : 'bg-white '
                    }
                `}>
                    <div className={`
                        rounded-full bg-white w-[25px] h-[25px] 
                        ${stepInfos['third'] === 3 ? '' : `border-2`} 
                        ${highContrast ? "blackBorder" : ""}`}
                    >
                        {stepInfos['third'] === 3 
                        ? <img className={`w-full select-none ${highContrast ? "brightness-0" : ""}`} src={check} alt="check image" /> 
                        : <span className={`select-none text-[#666] text-sm font-bold flex justify-center ${highContrast ? "highLabelThird" : ""}`}>3</span>}
                    </div>
                </div>
                <div className={`
                    w-full h-full flex justify-end items-center rounded-e-full 
                    ${stepInfos['fourth'] === 3 ? `${highContrast ? "highGenericWrapper" : "bg-sabin-red-default"} rounded-r-full ` : 'bg-white '}
                `}>
                    <div className={s.progressStepThree}>
                        {stepInfos['fourth'] === 3 
                        ? <img className={`w-full select-none ${highContrast ? "brightness-0" : ""}`} src={check} alt="check image" /> 
                        : <span className={`text-[#666] ${highContrast ? "highLabelThird" : ""}`}>4</span>}
                    </div>
                </div>
            </div>
            <div className={s.progressLabels}>
                <div>PEDIDO SOLICITADO</div>
                <div>SOLICITAÇÃO DE CANCELAMENTO</div>
                <div>ANÁLISE DE CANCELAMENTO</div>
                <div>PEDIDO LIBERADO</div>
            </div>
        </div>
    )
}

export default OrdersProgressBar;